import { render, staticRenderFns } from "./WhatIsSection.vue?vue&type=template&id=12138534"
import script from "./WhatIsSection.vue?vue&type=script&lang=ts"
export * from "./WhatIsSection.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports